import React, { ButtonHTMLAttributes } from "react";
import classNames from "classnames";
import * as Icons from "Components/Icons";


export type ModalCloseButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({ className, ...htmlProps }) => {
   const btnClasses = classNames("ls-modal-close", className);

   return (<button className={btnClasses} {...htmlProps}><Icons.Close className="ls-modal-close-icon" /></button>)
}

export default ModalCloseButton;